import axios from 'axios';
import {getHeader} from './user_api';
import {
    PROPERTY_VISIT_API_URL,
} from "../constants/api_routes";

export const createPVs = async (pvData) => {
    try {
        const res = await axios.post(`${PROPERTY_VISIT_API_URL}/create`, pvData, { headers: getHeader() });
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: error.message,
            status: error.response.status,
        });
    }
};

export const createPVAgent = async (pvData) => {
    try {
        const res = await axios.post(`${PROPERTY_VISIT_API_URL}/create_agent`, pvData, { headers: getHeader() });
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: error.message,
            status: error.response.status,
        });
    }
};

export const updatePVs = async (pvData) => {
    try {
        const res = await axios.post(`${PROPERTY_VISIT_API_URL}/update`, pvData, { headers: getHeader() });
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: error.message,
            status: error.response.status,
        });
    }
};

export const getPVReportById = async (reportId) => {
    try {
        const res = await axios.get(`${PROPERTY_VISIT_API_URL}/report/${reportId}`, { headers: getHeader() });
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const uploadPVTitleImage = async (formData) => {
    try {
        await axios.post(`${PROPERTY_VISIT_API_URL}/report/title`, formData , {headers: getHeader()});
        return ({
            success:true,
            statusMessage:"File Successfully uploaded"
        })
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const uploadPVChecklistDetails = async (formData) => {
    try {
        await axios.post(`${PROPERTY_VISIT_API_URL}/report/checklist`, formData , {headers: getHeader()});
        return ({
            success:true,
            statusMessage:"Details Successfully uploaded"
        })
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const uploadPVAlarmDetails = async (formData) => {
    let response;
    try {
        response = await axios.post(`${PROPERTY_VISIT_API_URL}/report/alarms`,formData,{headers: getHeader()});
        if(response.data.success){
            return ({
                success:true,
                statusMessage:"Alarms added successfully !!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:"Something Went Wrong. Please Try Again!"
        })
    }
};

export const uploadPVAlarmImages = async (formData) => {
    let response;
    try {
        response = await axios.post(`${PROPERTY_VISIT_API_URL}/report/alarm_images`,formData,{headers: getHeader()});
        if(response.data.success){
            return ({
                success:true,
                statusMessage:"Alarms added successfully !!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:"Something Went Wrong. Please Try Again!"
        })
    }
};


export const uploadPVRoomDetails = async (formData) => {
    let response;
    try {
        response = await axios.post(`${PROPERTY_VISIT_API_URL}/report/rooms`,formData,{headers: getHeader()});
        if (response.data.success) {
            return {
                success: true,
                statusMessage: "Report Submitted Successfully!!",
            };
        } else {
            return {
                success: false,
                statusMessage: response.data.error
                    ? response.data.error
                    : "Unknown server error",
            };
        }
    } catch (error) {
        let message = "";

        if (error.response) {
            if (error.response.data) {
                if (error.response.data.error) {
                    message = error.response.data.error;
                } else if (error.response.data.message) {
                    message = error.response.data.message;
                } else {
                    message = "Server responded with an error but no details.";
                }
            } else {
                message = "Server responded with no data.";
            }
        } else if (error.request) {
            message = "No response received from server.";
        } else if (error.message) {
            message = error.message;
        } else {
            message = String(error);
        }

        return {
            success: false,
            statusMessage: message,
        };
    }
};


export const uploadPVRoomImages = async (formData) => {
    let response;
    try {
        response = await axios.post(`${PROPERTY_VISIT_API_URL}/report/room_images`,formData,{headers: getHeader()});
        if(response.data.success){
            return ({
                success:true,
                statusMessage:"Room Image added successfully !!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:error
        })
    }
};

export const changePVStatus = async (URL, formdata) => {
    try {
        await axios.post(`${URL}/update_status`, formdata, {headers: getHeader()});
        return ({
            success: true,
            statusMessage: "PV Status Changed Successfully"
        });

    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};
export const recordEmailAttempt = async (URL, visitID) => {
    try {
        await axios.get(`${URL}/record_email_attempt?visit_id=${visitID}`,  {headers: getHeader()});
        return ({
            success: true,
            statusMessage: "Email attempt recorded Successfully"
        });

    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};
export const bulkConfirmPVs = async (URL, formdata) => {
    try {
        await axios.get(`${URL}/bulk_confirm?visit_ids=${formdata}`,  {headers: getHeader()});
        return ({
            success: true,
            statusMessage: "PV Status Changed Successfully"
        });

    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};





// WEBPACK FOOTER //
// ./src/data/property_visit_api.js